import { useState, useEffect } from "react";

const NON_CONFERENCE_HOSTS = [
  "staging.myconnect.ai",
  "dev.dpkaojmcwjhsg.amplifyapp.com",
  "da1.dpkaojmcwjhsg.amplifyapp.com",
  "prod.myconnect.ai",
  "testing.dpkaojmcwjhsg.amplifyapp.com",
  "localhost:3000",
  // "haa.myconnect.ai", // explicitly excluded
];

const useConference = () => {
  const [isConference, setIsConference] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const currentHost = window.location.host;
      const isNotConference = NON_CONFERENCE_HOSTS.includes(currentHost);
      setIsConference(!isNotConference);
    }
  }, []);

  return {
    isConference,
  };
};

export default useConference;